import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { AccordionItem } from '../../01-Atoms/AccordionItem/AccordionItem';
import {Section} from "../Section/Section";
import './Accordion.scss';
export const Accordion = ({ faqs }) => {

  const [isOpen, isOpenSet] = useState(Array(faqs.length).fill(false)) // use the faqs prop to make an array the correct length

  const handleClick = i => {
    let newArray = [...isOpen]; // expand current array into new var
    newArray[i] = !newArray[i] // flip the boolean of the clicked array item
    isOpenSet(newArray) // update state with he new array
  }

  /**
   * Handle the arrow up and arrow down actions.
   *
   * @param {Event} event
   *   The triggered event.
   */
  const handleKeyDown = event => {
    if (event.code  === "ArrowDown" && event.target.classList.contains('c-accordion-item__question')) {
      const children = event.target.closest('.c-accordion__container').querySelectorAll('.c-accordion-item__question')
      for (let i = 0; i < children.length; i++) {
        if (event.target === children[i]) {
          if (i === (children.length -1)) {
            children[0].focus()
          }
          else {
            children[i+1].focus()
          }

          break
        }
      }
      event.preventDefault()
    }

    if (event.code  === "ArrowUp" && event.target.classList.contains('c-accordion-item__question')) {
      const children = event.target.closest('.c-accordion__container').querySelectorAll('.c-accordion-item__question')
      for (let i = 0; i < children.length; i++) {
        if (event.target === children[i]) {
          if (i === 0) {
            children[children.length-1].focus()
          }
          else {
            children[i-1].focus()
          }

          break
        }
      }
      event.preventDefault()
    }
  }


  return (
    <Section>
      <div className="c-accordion__container" onKeyDown={handleKeyDown}>
        {faqs.map((faq, i) => {
          return (
            <AccordionItem key={i} question={faq.question} isOpen={isOpen[i]} answer={faq.answer} onClick={() => handleClick(i)} />
          )
        })}
      </div>
    </Section>
  )
}


Accordion.propTypes = {
  faqs: PropTypes.array.isRequired,
}
